import Popup from '../../Popup';
import { CLICK_EVENT_TRIGGER, UI_CONTROLS_ACTION_CATEGORY, FAC_EVENT_ACTION_TYPE, FAC_MODULE_NAME } from '../../../../../constants';
import { trackingEvent } from '../../../../../utils';

const ErrorDifferentSegments = ({ isShowPopup = false, onClose, labels }) => {

  const handleClose = () => {
    onClose();
    trackingEvent({
      event: CLICK_EVENT_TRIGGER,
      type: FAC_EVENT_ACTION_TYPE,
      label: `${FAC_MODULE_NAME}:invalid product:close`,
      category: UI_CONTROLS_ACTION_CATEGORY,
      custom: {
        'link_metadata': {
          'destination_url': '',
        },
        metadata: {
          'target_url': '',
        },
      },
    });
  };

  const handleBack = () => {
    onClose();
    trackingEvent({
      event: CLICK_EVENT_TRIGGER,
      type: FAC_EVENT_ACTION_TYPE,
      label: `${FAC_MODULE_NAME}:invalid product:${labels.backButton}`,
      category: UI_CONTROLS_ACTION_CATEGORY,
      custom: {
        'link_metadata': {
          'destination_url': '',
        },
        metadata: {
          'target_url': '',
        },
      },
    });
  };

  return (
    <Popup
      showPopup={isShowPopup}
      onHide={handleClose}
      popupClass="relative"
      popupSizeClass="md:max-w-570"
      popupWrapperClass="p-0"
      btnClass="hover:text-primary-100 right-24"
    >
      <div className="min-h-[300px] flex items-center px-40 py-25 justify-center">
        <div className="text-center p-6 last-mb-none">
          <h4>{labels.headline}</h4>
          <p>
            {labels.description}
          </p>
          <p>
            <button type="button" className="btn btn-outline-primary" onClick={handleBack}>
              {labels.backButton}
            </button>
          </p>
        </div>
      </div>
    </Popup>
  );
};

export default ErrorDifferentSegments;
